t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="`How many windows do you have?`"
        :counter.sync="windows"
        :image="require('@/assets/window.svg')"
      >
      </CountImageInput>
      <one-button
        type="primary"
        class="next-btn"
        :class="{ disabled: windows <= 0 }"
        @click.native="next()"
      >
        Next
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountImageInput from "../../components/CountImageInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import { getStepIndex, redirectToUnselectedStepIfAny, getPrevStepUrl, getNextStepUrl } from "@/utils/steps.js";

export default {
  name: "Windows",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("windows"),
      getPrevStepUrl: getPrevStepUrl,
      windows: this.$store.state.data.windows
    };
  },
  watch: {
    windows: function() {
      this.updateWindows(this.windows);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateWindows"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
